export const IconVerifiedBadge = ({ size = 21, className, ...props }) => {
  return (
    <i
      style={{ width: size, height: size }}
      className={`flex items-center justify-center ${className}`}
      {...props}
    >
      <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="12" cy="12.5" r="12" fill="#1F4444" />
          <g>
            <path
              d="M4.65623 6.78853C4.65625 6.79023 4.65624 6.79195 4.65622 6.79368C4.65624 6.79541 4.65625 6.79713 4.65623 6.79883C4.65416 7.0224 4.3031 7.0224 4.30103 6.79883C4.30102 6.79713 4.30102 6.79541 4.30105 6.79368C4.30102 6.79195 4.30102 6.79023 4.30103 6.78853C4.3031 6.56496 4.65416 6.56496 4.65623 6.78853Z"
              fill="white"
              stroke="#1F4444"
            />
            <path
              d="M4.23851 7.35274C4.23852 7.35444 4.23852 7.35616 4.23849 7.35789C4.23852 7.35962 4.23852 7.36134 4.23851 7.36304C4.23644 7.58661 3.88538 7.58661 3.88331 7.36304C3.88329 7.36134 3.8833 7.35962 3.88332 7.35789C3.8833 7.35616 3.88329 7.35444 3.88331 7.35274C3.88538 7.12917 4.23644 7.12917 4.23851 7.35274Z"
              fill="white"
              stroke="#1F4444"
            />
            <path
              d="M3.94601 7.94285C3.94935 8.17329 3.5875 8.17329 3.59084 7.94285C3.5875 7.71241 3.94935 7.71241 3.94601 7.94285Z"
              fill="white"
            />
            <path
              d="M3.65353 8.50682C3.65687 8.73726 3.29502 8.73726 3.29836 8.50682C3.29502 8.27637 3.65687 8.27637 3.65353 8.50682Z"
              fill="white"
            />
            <path
              d="M3.4028 9.07102C3.40614 9.30147 3.04429 9.30147 3.04763 9.07102C3.04429 8.84058 3.40614 8.84058 3.4028 9.07102Z"
              fill="white"
            />
            <path
              d="M3.19381 9.63499C3.19716 9.86543 2.8353 9.86543 2.83865 9.63499C2.8353 9.40455 3.19716 9.40455 3.19381 9.63499Z"
              fill="white"
            />
            <path
              d="M3.02658 10.1992C3.02992 10.4296 2.66807 10.4296 2.67141 10.1992C2.66807 9.96876 3.02992 9.96876 3.02658 10.1992Z"
              fill="white"
            />
            <path
              d="M2.92233 10.7632C2.92567 10.9936 2.56382 10.9936 2.56716 10.7632C2.56382 10.5327 2.92567 10.5327 2.92233 10.7632Z"
              fill="white"
            />
            <path
              d="M2.81784 11.3274C2.82118 11.5578 2.45933 11.5578 2.46267 11.3274C2.45933 11.0969 2.82118 11.0969 2.81784 11.3274Z"
              fill="white"
            />
            <path
              d="M2.77609 11.9333C2.77943 12.1638 2.41758 12.1638 2.42092 11.9333C2.41758 11.7029 2.77943 11.7029 2.77609 11.9333Z"
              fill="white"
            />
            <path
              d="M2.75509 12.539C2.75844 12.7695 2.39658 12.7695 2.39993 12.539C2.39658 12.3086 2.75844 12.3086 2.75509 12.539Z"
              fill="white"
            />
            <path
              d="M2.77609 13.145C2.77943 13.3754 2.41758 13.3754 2.42092 13.145C2.41758 12.9146 2.77943 12.9146 2.77609 13.145Z"
              fill="white"
            />
            <path
              d="M2.83859 13.751C2.84193 13.9814 2.48008 13.9814 2.48342 13.751C2.48008 13.5205 2.84193 13.5205 2.83859 13.751Z"
              fill="white"
            />
            <path
              d="M2.94308 14.3567C2.94642 14.5871 2.58457 14.5871 2.58791 14.3567C2.58457 14.1262 2.94642 14.1262 2.94308 14.3567Z"
              fill="white"
            />
            <path
              d="M3.06857 14.9626C3.07191 15.1931 2.71006 15.1931 2.7134 14.9626C2.71006 14.7322 3.07191 14.7322 3.06857 14.9626Z"
              fill="white"
            />
            <path
              d="M3.25656 15.5686C3.2599 15.799 2.89805 15.799 2.90139 15.5686C2.89805 15.3381 3.2599 15.3381 3.25656 15.5686Z"
              fill="white"
            />
            <path
              d="M3.44455 16.1743C3.44789 16.4047 3.08604 16.4047 3.08938 16.1743C3.08604 15.9439 3.44789 15.9439 3.44455 16.1743Z"
              fill="white"
            />
            <path
              d="M3.73703 16.7803C3.74037 17.0107 3.37852 17.0107 3.38186 16.7803C3.37852 16.5498 3.74037 16.5498 3.73703 16.7803Z"
              fill="white"
            />
            <path
              d="M4.07126 17.3862C4.0746 17.6167 3.71274 17.6167 3.71609 17.3862C3.71274 17.1558 4.0746 17.1558 4.07126 17.3862Z"
              fill="white"
            />
            <path
              d="M4.42648 17.9292C4.42982 18.1596 4.06797 18.1596 4.07131 17.9292C4.06797 17.6987 4.42982 17.6987 4.42648 17.9292Z"
              fill="white"
            />
            <path
              d="M4.80246 18.4306C4.8058 18.6611 4.44395 18.6611 4.44729 18.4306C4.44395 18.2002 4.8058 18.2002 4.80246 18.4306Z"
              fill="white"
            />
            <path
              d="M5.17868 18.8904C5.18202 19.1208 4.82017 19.1208 4.82351 18.8904C4.82017 18.6599 5.18202 18.6599 5.17868 18.8904Z"
              fill="white"
            />
            <path
              d="M5.6174 19.3081C5.62074 19.5385 5.25889 19.5385 5.26223 19.3081C5.25889 19.0776 5.62074 19.0776 5.6174 19.3081Z"
              fill="white"
            />
            <path
              d="M6.03512 19.7051C6.03847 19.9355 5.67661 19.9355 5.67995 19.7051C5.67661 19.4746 6.03847 19.4746 6.03512 19.7051Z"
              fill="white"
            />
            <path
              d="M6.53659 20.102C6.53993 20.3325 6.17808 20.3325 6.18142 20.102C6.17808 19.8716 6.53993 19.8716 6.53659 20.102Z"
              fill="white"
            />
            <path
              d="M7.0798 20.4783C7.08314 20.7087 6.72129 20.7087 6.72463 20.4783C6.72129 20.2478 7.08314 20.2478 7.0798 20.4783Z"
              fill="white"
            />
            <path
              d="M7.66476 20.8125C7.6681 21.0429 7.30625 21.0429 7.30959 20.8125C7.30625 20.582 7.6681 20.582 7.66476 20.8125Z"
              fill="white"
            />
            <path
              d="M8.27072 21.1257C8.27406 21.3562 7.91221 21.3562 7.91555 21.1257C7.91221 20.8953 8.27406 20.8953 8.27072 21.1257Z"
              fill="white"
            />
            <path
              d="M8.89743 21.3764C8.90077 21.6069 8.53892 21.6069 8.54226 21.3764C8.53892 21.146 8.90077 21.146 8.89743 21.3764Z"
              fill="white"
            />
            <path
              d="M9.54513 21.6064C9.54848 21.8369 9.18662 21.8369 9.18996 21.6064C9.18662 21.376 9.54848 21.376 9.54513 21.6064Z"
              fill="white"
            />
            <path
              d="M10.2136 21.7734C10.2169 22.0039 9.85508 22.0039 9.85842 21.7734C9.85508 21.543 10.2169 21.543 10.2136 21.7734Z"
              fill="white"
            />
            <path
              d="M10.882 21.8989C10.8854 22.1293 10.5235 22.1293 10.5269 21.8989C10.5235 21.6685 10.8854 21.6685 10.882 21.8989Z"
              fill="white"
            />
            <path
              d="M11.5507 21.9614C11.5541 22.1918 11.1922 22.1918 11.1956 21.9614C11.1922 21.731 11.5541 21.731 11.5507 21.9614Z"
              fill="white"
            />
            <path
              d="M12.2192 21.9824C12.2225 22.2128 11.8607 22.2128 11.864 21.9824C11.8607 21.752 12.2225 21.752 12.2192 21.9824Z"
              fill="white"
            />
            <path
              d="M12.8879 21.9407C12.8912 22.1711 12.5294 22.1711 12.5327 21.9407C12.5294 21.7102 12.8912 21.7102 12.8879 21.9407Z"
              fill="white"
            />
            <path
              d="M13.5564 21.8779C13.5597 22.1083 13.1979 22.1083 13.2012 21.8779C13.1979 21.6475 13.5597 21.6475 13.5564 21.8779Z"
              fill="white"
            />
            <path
              d="M14.2041 21.7527C14.2074 21.9831 13.8456 21.9831 13.8489 21.7527C13.8456 21.5222 14.2074 21.5222 14.2041 21.7527Z"
              fill="white"
            />
            <path
              d="M14.8308 21.5854C14.8341 21.8159 14.4723 21.8159 14.4756 21.5854C14.4723 21.355 14.8341 21.355 14.8308 21.5854Z"
              fill="white"
            />
            <path
              d="M15.4367 21.3764C15.4401 21.6069 15.0782 21.6069 15.0816 21.3764C15.0782 21.146 15.4401 21.146 15.4367 21.3764Z"
              fill="white"
            />
            <path
              d="M16.0424 21.1257C16.0458 21.3562 15.6839 21.3562 15.6873 21.1257C15.6839 20.8953 16.0458 20.8953 16.0424 21.1257Z"
              fill="white"
            />
            <path
              d="M16.6484 20.8125C16.6517 21.0429 16.2899 21.0429 16.2932 20.8125C16.2899 20.582 16.6517 20.582 16.6484 20.8125Z"
              fill="white"
            />
            <path
              d="M17.2334 20.4573C17.2367 20.6877 16.8749 20.6877 16.8782 20.4573C16.8749 20.2268 17.2367 20.2268 17.2334 20.4573Z"
              fill="white"
            />
            <path
              d="M17.7976 20.102C17.8009 20.3325 17.4391 20.3325 17.4424 20.102C17.4391 19.8716 17.8009 19.8716 17.7976 20.102Z"
              fill="white"
            />
            <path
              d="M18.2988 19.6843C18.3021 19.9147 17.9403 19.9147 17.9436 19.6843C17.9403 19.4539 18.3021 19.4539 18.2988 19.6843Z"
              fill="white"
            />
            <path
              d="M18.8003 19.2456C18.8036 19.476 18.4417 19.476 18.4451 19.2456C18.4417 19.0151 18.8036 19.0151 18.8003 19.2456Z"
              fill="white"
            />
            <path
              d="M19.239 18.7859C19.2423 19.0163 18.8805 19.0163 18.8838 18.7859C18.8805 18.5554 19.2423 18.5554 19.239 18.7859Z"
              fill="white"
            />
            <path
              d="M19.6569 18.2844C19.6603 18.5148 19.2984 18.5148 19.3018 18.2844C19.2984 18.054 19.6603 18.054 19.6569 18.2844Z"
              fill="white"
            />
            <path
              d="M20.0122 17.7622C20.0155 17.9926 19.6537 17.9926 19.657 17.7622C19.6537 17.5317 20.0155 17.5317 20.0122 17.7622Z"
              fill="white"
            />
            <path
              d="M20.3672 17.219C20.3705 17.4494 20.0086 17.4494 20.012 17.219C20.0086 16.9885 20.3705 16.9885 20.3672 17.219Z"
              fill="white"
            />
            <path
              d="M20.6596 16.6548C20.663 16.8852 20.3011 16.8852 20.3045 16.6548C20.3011 16.4243 20.663 16.4243 20.6596 16.6548Z"
              fill="white"
            />
            <path
              d="M20.9104 16.0908C20.9137 16.3212 20.5519 16.3212 20.5552 16.0908C20.5519 15.8604 20.9137 15.8604 20.9104 16.0908Z"
              fill="white"
            />
            <path
              d="M21.1403 15.4848C21.1437 15.7153 20.7818 15.7153 20.7852 15.4848C20.7818 15.2544 21.1437 15.2544 21.1403 15.4848Z"
              fill="white"
            />
            <path
              d="M21.3283 14.8581C21.3317 15.0886 20.9698 15.0886 20.9732 14.8581C20.9698 14.6277 21.3317 14.6277 21.3283 14.8581Z"
              fill="white"
            />
            <path
              d="M21.4536 14.2522C21.4569 14.4826 21.0951 14.4826 21.0984 14.2522C21.0951 14.0217 21.4569 14.0217 21.4536 14.2522Z"
              fill="white"
            />
            <path
              d="M21.5373 13.6047C21.5407 13.8352 21.1788 13.8352 21.1822 13.6047C21.1788 13.3743 21.5407 13.3743 21.5373 13.6047Z"
              fill="white"
            />
            <path
              d="M21.5998 12.936C21.6032 13.1665 21.2413 13.1665 21.2447 12.936C21.2413 12.7056 21.6032 12.7056 21.5998 12.936Z"
              fill="white"
            />
            <path
              d="M21.5998 12.2883C21.6032 12.5188 21.2413 12.5188 21.2447 12.2883C21.2413 12.0579 21.6032 12.0579 21.5998 12.2883Z"
              fill="white"
            />
            <path
              d="M21.5791 11.6199C21.5824 11.8503 21.2206 11.8503 21.2239 11.6199C21.2206 11.3894 21.5824 11.3894 21.5791 11.6199Z"
              fill="white"
            />
            <path
              d="M21.4953 10.9931C21.4987 11.2236 21.1368 11.2236 21.1402 10.9931C21.1368 10.7627 21.4987 10.7627 21.4953 10.9931Z"
              fill="white"
            />
            <path
              d="M21.3701 10.3664C21.3734 10.5969 21.0116 10.5969 21.0149 10.3664C21.0116 10.136 21.3734 10.136 21.3701 10.3664Z"
              fill="white"
            />
            <path
              d="M21.2028 9.73948C21.2062 9.96992 20.8443 9.96992 20.8477 9.73948C20.8443 9.50904 21.2062 9.50904 21.2028 9.73948Z"
              fill="white"
            />
            <path
              d="M20.9731 9.11277C20.9765 9.34321 20.6146 9.34321 20.6179 9.11277C20.6146 8.88233 20.9765 8.88233 20.9731 9.11277Z"
              fill="white"
            />
            <path
              d="M20.7224 8.48606C20.7257 8.7165 20.3639 8.7165 20.3672 8.48606C20.3639 8.25562 20.7257 8.25562 20.7224 8.48606Z"
              fill="white"
            />
            <path
              d="M20.3881 7.85935C20.3915 8.0898 20.0296 8.0898 20.033 7.85935C20.0296 7.62891 20.3915 7.62891 20.3881 7.85935Z"
              fill="white"
            />
            <path
              d="M20.0329 7.27439C20.0363 7.50483 19.6744 7.50483 19.6778 7.27439C19.6744 7.04395 20.0363 7.04395 20.0329 7.27439Z"
              fill="white"
            />
            <path
              d="M19.6152 6.68919C19.6185 6.91963 19.2567 6.91963 19.26 6.68919C19.2567 6.45875 19.6185 6.45875 19.6152 6.68919Z"
              fill="white"
            />
            <path
              d="M19.1555 6.16697C19.1588 6.39741 18.797 6.39741 18.8003 6.16697C18.797 5.93653 19.1588 5.93653 19.1555 6.16697Z"
              fill="white"
            />
            <path
              d="M18.654 5.64475C18.6574 5.8752 18.2955 5.8752 18.2989 5.64475C18.2955 5.41431 18.6574 5.41431 18.654 5.64475Z"
              fill="white"
            />
            <path
              d="M18.1318 5.18504C18.1351 5.41548 17.7733 5.41548 17.7766 5.18504C17.7733 4.9546 18.1351 4.9546 18.1318 5.18504Z"
              fill="white"
            />
            <path
              d="M17.5468 4.74632C17.5502 4.97676 17.1883 4.97676 17.1917 4.74632C17.1883 4.51588 17.5502 4.51588 17.5468 4.74632Z"
              fill="white"
            />
            <path
              d="M16.9409 4.34934C16.9442 4.57979 16.5824 4.57979 16.5857 4.34934C16.5824 4.1189 16.9442 4.1189 16.9409 4.34934Z"
              fill="white"
            />
            <path
              d="M16.3349 4.03587C16.3383 4.26631 15.9764 4.26631 15.9798 4.03587C15.9764 3.80543 16.3383 3.80543 16.3349 4.03587Z"
              fill="white"
            />
            <path
              d="M15.6665 3.72264C15.6698 3.95308 15.308 3.95308 15.3113 3.72264C15.308 3.49219 15.6698 3.49219 15.6665 3.72264Z"
              fill="white"
            />
            <path
              d="M14.9353 3.4719C14.9386 3.70234 14.5768 3.70234 14.5801 3.4719C14.5768 3.24146 14.9386 3.24146 14.9353 3.4719Z"
              fill="white"
            />
            <path
              d="M14.1413 3.28391C14.1447 3.51436 13.7828 3.51436 13.7862 3.28391C13.7828 3.05347 14.1447 3.05347 14.1413 3.28391Z"
              fill="white"
            />
            <path
              d="M13.3056 3.13767C13.309 3.36812 12.9471 3.36812 12.9505 3.13767C12.9471 2.90723 13.309 2.90723 13.3056 3.13767Z"
              fill="white"
            />
            <path
              d="M12.4909 3.07493C12.4943 3.30537 12.1324 3.30537 12.1358 3.07493C12.1324 2.84449 12.4943 2.84449 12.4909 3.07493Z"
              fill="white"
            />
            <path
              d="M11.6342 3.09593C11.6376 3.32637 11.2757 3.32637 11.2791 3.09593C11.2757 2.86549 11.6376 2.86549 11.6342 3.09593Z"
              fill="white"
            />
            <path
              d="M10.7778 3.17942C10.7811 3.40986 10.4193 3.40986 10.4226 3.17942C10.4193 2.94898 10.7811 2.94898 10.7778 3.17942Z"
              fill="white"
            />
            <path
              d="M9.9421 3.34641C9.94545 3.57686 9.58359 3.57686 9.58694 3.34641C9.58359 3.11597 9.94545 3.11597 9.9421 3.34641Z"
              fill="white"
            />
            <path
              d="M9.12716 3.5764C9.13051 3.80684 8.76865 3.80684 8.772 3.5764C8.76865 3.34595 9.13051 3.34595 9.12716 3.5764Z"
              fill="white"
            />
            <path
              d="M8.39596 3.86888C8.3993 4.09932 8.03745 4.09932 8.04079 3.86888C8.03745 3.63843 8.3993 3.63843 8.39596 3.86888Z"
              fill="white"
            />
            <path
              d="M7.70651 4.18211C7.70985 4.41255 7.348 4.41255 7.35134 4.18211C7.348 3.95167 7.70985 3.95167 7.70651 4.18211Z"
              fill="white"
            />
            <path
              d="M7.01706 4.60008C7.0204 4.83052 6.65855 4.83052 6.66189 4.60008C6.65855 4.36964 7.0204 4.36964 7.01706 4.60008Z"
              fill="white"
            />
            <path
              d="M6.3276 5.08055C6.33095 5.31099 5.96909 5.31099 5.97244 5.08055C5.96909 4.8501 6.33095 4.8501 6.3276 5.08055Z"
              fill="white"
            />
            <path
              d="M5.6799 5.64475C5.68324 5.8752 5.32139 5.8752 5.32473 5.64475C5.32139 5.41431 5.68324 5.41431 5.6799 5.64475Z"
              fill="white"
            />
            <path
              d="M5.11593 6.22972C5.11928 6.46016 4.75742 6.46016 4.76077 6.22972C4.75742 5.99927 5.11928 5.99927 5.11593 6.22972Z"
              fill="white"
            />
          </g>
          <path
            d="M8 14.5V12L11 15.5L16 7.5H18L11 18L8 14.5Z"
            fill="white"
            stroke="white"
            strokeWidth="0.25"
          />
          <circle
            cx="12"
            cy="12.5"
            r="10.95"
            stroke="white"
            strokeWidth="0.5"
          />
        </g>
      </svg>
    </i>
  );
};
